// Shared between the Information step's inline validation messages
// (step-info.component.ts) and DisclosureStateService.canProceedToStep2, so
// the wizard can never advance past a client/advisor name it displayed as
// invalid — one set of rules, not two that could quietly drift apart.

export const NAME_MAX_LENGTH = 50;
// Letters, digits, and spaces — a name field, so bare digits/symbols on
// their own are rejected, but a real name still needs the space between
// words.
export const NAME_ALLOWED_CHARS = /^[A-Za-z0-9 ]*$/;
export const NAME_STARTS_WITH_LETTER = /^[A-Za-z]/;
export const NAME_ALL_DIGITS = /^\d+$/;

/** Not required — empty passes. Once something is entered, it must start
 *  with a letter, contain only letters/digits/spaces, not be all-digits,
 *  and stay within NAME_MAX_LENGTH. */
export function isValidName(value: string | null | undefined): boolean {
  const v = value ?? '';
  if (!v) return true;
  return v.length <= NAME_MAX_LENGTH
    && !NAME_ALL_DIGITS.test(v)
    && NAME_STARTS_WITH_LETTER.test(v)
    && NAME_ALLOWED_CHARS.test(v);
}
